import firebase from 'firebase'
import 'firebase/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyBeF5tu38Py3FGGK5PVOklPtw7xClyudwc",
    authDomain: "netflix-clone-f1081.firebaseapp.com",
    projectId: "netflix-clone-f1081",
    storageBucket: "netflix-clone-f1081.appspot.com",
    messagingSenderId: "134143507523",
    appId: "1:134143507523:web:ec66a40bed65e8a0d528f6",
    measurementId: "G-GDK5C65NEL"
};

// V8 
const firebaseApp = firebase.initializeApp(firebaseConfig)
const auth = firebase.auth();
const db = firebase.firestore();

export { auth };
export default db